import React, {Component} from 'react';
import './styles/css/index.css';
import './styles/scss/index.scss';
import './App.scss';
import Navigation from "./components/navigation/Navigation";
import About from "./components/about/About";
import WhyUs from "./components/whyUs/WhyUs";
import Footer from "./components/footer/Footer";
import Contact from "./components/contact/Contact";
import Reference from "./components/reference/Reference";
import Home from "./components/home/Home";
import Motto from "./components/motto/Motto";
import Service from "./components/service/Service";
import GalleryBam from "./components/gallery/GalleryBam";

class App extends Component {

    constructor(props) {
        super(props);
        this.ref_about = React.createRef();
        this.ref_reference = React.createRef();
        this.ref_services = React.createRef();
        this.ref_gallery = React.createRef();
    }

    render() {
        return (
            <div className="App">
                <Navigation ref_about={this.ref_about}
                            ref_reference={this.ref_reference}
                            ref_services={this.ref_services}
                            ref_gallery={this.ref_gallery}/>
                <Home/>
                <About ref_about={this.ref_about}/>

                <GalleryBam ref_gallery={this.ref_gallery}/>
                <Motto/>

                {/*
                <Element/>
*/}

                <WhyUs/>
                <Reference ref_reference={this.ref_reference}/>
                <Service ref_services={this.ref_services}/>
                {/*<Contact/>*/}
                <Footer/>
            </div>
        );
    }
}

export default App;
